<a mat-button class="btn-primary" (click)="openListModal()">
    {{reportType.reportTypeName}}
</a>